import { useState } from 'react';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import { AdminMicrostories } from '@platform/client';
import { MicrostoryForm, MicrostoryFormData } from './MicrostoryForm';

type CreateMicrostoryModalProps = {
  onClose: () => void;
};

export const CreateMicrostoryModal = (props: CreateMicrostoryModalProps) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const { ...functions } = useForm<MicrostoryFormData>({
    defaultValues: { consentToShare: false, storyDate: new Date() },
  });
  const queryClient = useQueryClient();
  const createMicrostoryMutator = AdminMicrostories.useCreateMicrostory({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AdminMicrostories.getGetAdminMicrostoriesQueryKey(),
        });
        setModalStage('success');
      },
    },
  });

  const onSubmit: SubmitHandler<MicrostoryFormData> = (data) => {
    createMicrostoryMutator.mutate({
      data: {
        contactName: data.contactName,
        organizationName: data.organizationName,
        microstory: data.microstory,
        userType: data.userType,
        source: data.source,
        storyDate: data.storyDate.toISOString(),
        urlOrFileRef: data.urlOrFileRef || null,
        consentToShare: data.consentToShare,
        corporateClientId: data.corporateClientId ? Number(data.corporateClientId) : null,
        impactPartnerId: data.impactPartnerId ? Number(data.impactPartnerId) : null,
        userId: data.userId ?? null,
        organizationId: data.organizationId ?? null,
      },
    });
  };

  return (
    <AdminFormModal
      variant='full-screen'
      title='Create Microstory'
      modalStage={modalStage}
      onClose={props.onClose}
      submitCTA={{ text: 'Create Microstory', callback: () => functions.handleSubmit(onSubmit)() }}
    >
      <MicrostoryForm {...functions} />
    </AdminFormModal>
  );
};
